module.exports = __webpack_public_path__ + "img/sunset.c533890d.svg";